import { zodResolver } from "@hookform/resolvers/zod"
import { Box, Button } from "@mui/material"
import type { FC } from "react"
import React from "react"
import { FormProvider, useForm } from "react-hook-form"

import PriceChangeBulkOptionsForm from "@/screens/Pricing/components/forms/PriceChangeBulkOptionsForm"
import { PricingNumericTypeValues } from "@/screens/Pricing/constants"
import type { BulkUpdateFormValues } from "@/screens/Pricing/schema/BulkUpdateSchema"
import { BulkUpdateSchema } from "@/screens/Pricing/schema/BulkUpdateSchema"

const BulkUpdateOptions: FC = () => {
  const methods = useForm({
    defaultValues: {
      acceptedCost: null,
      acceptedCostType: PricingNumericTypeValues.Percent,
      includeMargin: false,
      priceChange: null,
      priceChangeType: PricingNumericTypeValues.Percent,
      expirationDate: null,
      effectiveDate: null,
    },
    mode: "onChange",
    resolver: zodResolver(BulkUpdateSchema),
  })

  const {
    formState: { isDirty, isValid },
    reset,
    handleSubmit,
  } = methods

  const onSubmitData = async (data: BulkUpdateFormValues) => {
    console.log(data)
  }

  const handleClear = () => {
    reset()
  }

  return (
    <Box className='flex w-full flex-row justify-between gap-3'>
      <FormProvider {...methods}>
        <PriceChangeBulkOptionsForm />
      </FormProvider>

      <Box className='mt-5 flex flex-row justify-end gap-3 text-nowrap'>
        <Button
          data-testid='pricing.bulk-update.submit-button'
          aria-label='filter'
          className='capitalize'
          variant='outlined'
          disabled={!isValid || !isDirty}
          onClick={handleSubmit(onSubmitData)}
        >
          Apply Bulk Update
        </Button>
        <Button className='capitalize' onClick={handleClear}>
          Clear all
        </Button>
      </Box>
    </Box>
  )
}
export default BulkUpdateOptions
